module.exports = __webpack_public_path__ + "img/slideshow-premiere-couverture-murmure.d1da46ef.png";